import { z } from "zod"

export const automatedMessagesFormDefaultValues = {
  before_checkin_subject: "",
  before_checkin_content: "",
  minutes_before_checkin: null,
  before_checkin_cc_camp_notification_emails: false,
  after_checkout_subject: "",
  after_checkout_content: "",
  minutes_after_checkout: null,
  after_checkout_cc_camp_notification_emails: false,
}

export const AutomatedMessageSchema = z
  .object({
    minutes_before_checkin: z.number().nullable().optional(),
    before_checkin_subject: z.string().optional(),
    before_checkin_content: z.string().optional(),
    before_checkin_cc_camp_notification_emails: z.boolean().optional(),
    minutes_after_checkout: z.number().nullable().optional(),
    after_checkout_subject: z.string().optional(),
    after_checkout_content: z.string().optional(),
    after_checkout_cc_camp_notification_emails: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.minutes_before_checkin !== null && typeof data.minutes_before_checkin === "number") {
      if (!data.before_checkin_subject?.length) {
        ctx.addIssue({
          path: ["before_checkin_subject"],
          code: z.ZodIssueCode.custom,
          message: "Before check-in email subject can't be blank",
        })
      }
      if (!data.before_checkin_content?.length) {
        ctx.addIssue({
          path: ["before_checkin_content"],
          code: z.ZodIssueCode.custom,
          message: "Before check-in email content can't be blank",
        })
      }
    }

    if (data.minutes_after_checkout !== null && typeof data.minutes_after_checkout === "number") {
      if (!data.after_checkout_subject?.length) {
        ctx.addIssue({
          path: ["after_checkout_subject"],
          code: z.ZodIssueCode.custom,
          message: "After check-out email subject can't be blank",
        })
      }
      if (!data.after_checkout_content?.length) {
        ctx.addIssue({
          path: ["after_checkout_content"],
          code: z.ZodIssueCode.custom,
          message: "After check-out email content can't be blank",
        })
      }
    }
  })

export type AutomatedMessageType = z.infer<typeof AutomatedMessageSchema>
